import React from 'react'
import {Button, Form, Modal} from "react-bootstrap";

export const ReminderModal = ({showCreateModal, handleCloseModal, submitHandled, isNewReminder, reminder, setReminder}:any) => {
    return (
        <Modal show={showCreateModal} onHide={handleCloseModal} size="lg">
            <Form>
                <Modal.Header closeButton className='bg-teal'>
                    <Modal.Title>{isNewReminder ? 'Add Reminder' : 'Update Reminder'}</Modal.Title>
                </Modal.Header>
                <Modal.Body className='row d-flex align-items-center'>
                    <textarea onChange={(e) => {setReminder(e.target.value)}}>{reminder}</textarea>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Cancel
                    </Button>
                    {
                        isNewReminder === false &&
                        <Button className='btn-light' onClick={() => {submitHandled('delete')}}>
                            Delete
                        </Button>
                    }
                    <Button className='btn-teal' onClick={() => {submitHandled('save')}}>
                        {isNewReminder ? 'Save' : 'Update'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}
